import React, { useState } from 'react'
import ConfirmationDialog from 'components/Modal/ConfirmationDialog/ConfirmationDialog';
import FoodItemsContainer from './container';
import { useChangeFoodItemStatusMutation, useDeleteFoodItemMutation, useGetListFoodItemsQuery } from './services';
import { useGetCategoriesQuery } from 'pages/categories/services';
import { useNavigate } from 'react-router-dom';
import AddOnsViewModal from 'components/Modal/AddOnsDialog/AddOnsViewModal';

const FoodItems = () => {
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    // const [open, setOpen] = useState(false);
    const [editingItems, setEditingItems] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [delData, setDelData] = useState(false);
    const [togglingItemId, setTogglingItemId] = useState(null);
    const [viewAddOnsOpen, setViewAddOnsOpen] = useState(false);
    const [selectedItemForAddOns, setSelectedItemForAddOns] = useState(null);

    const { data: categoryData, isLoading: catLoading } = useGetCategoriesQuery()
    const hasCategories = !catLoading && categoryData?.data?.records?.length == 0

    const { data: itemsData, isLoading, isError } = useGetListFoodItemsQuery({
         // category: activeCategoryId
        category: selectedCategory || undefined
    });

    // const [addCategory, { isLoading: adding }] = useAddCategoriesMutation();
    // const [updateCategory, { isLoading: updating }] = useUpdateCategoriesMutation();
    const [deleteFoodItem, { isLoading: isDeleteLoading }] = useDeleteFoodItemMutation();
    const [changeStatus, { isLoading: isChangeStatusLoading }] = useChangeFoodItemStatusMutation();

    const filteredItems = itemsData?.data?.records?.filter(cat =>
        cat.name.toLowerCase().includes(searchQuery.trim().toLowerCase())
    ) ?? [];


    const handleAddBtn = () => {
        setEditingItems(null);
        navigate("/food-items/manage-food-items")
        // setOpen(true);
    };

    const handleEdit = (item) => {
        setEditingItems(item);
        navigate("/food-items/manage-food-items", {
            state: {
                item
            }
        })
        // setOpen(true);
    };

    const handleDelete = (category) => {
        setConfirmDialogOpen(true);
        setDelData(category);
    }

    const handleToggle = async (category) => {
        setTogglingItemId(category.id);
        try {
            const toggleRes = await changeStatus({
                id: category.id,
                body: !category.active_status
            })
        } catch (err) {
            console.error('Failed to change status', err);
        } finally {
            setTogglingItemId(null);
        }
    }

    const handleViewAddOns = (item) => {
        setSelectedItemForAddOns(item);
        setViewAddOnsOpen(true);
    }

    const handleCloseAddOns = () => {
        setViewAddOnsOpen(false);
        setSelectedItemForAddOns(null);
    }

    // const handleClose = () => {
    //     // setOpen(false);
    //     setEditingItems(null);
    // };

    // const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    //     try {
    //     if (editingItems) {
    //         // await updateCategory({ id: editingItems.id, ...values }).unwrap();
    //     } else {
    //         // await addCategory(values);
    //     }
    //     handleClose();
    //     } catch (error) {
    //     setErrors(error.data?.errors || {});
    //     } finally {
    //     setSubmitting(false);
    //     }
    // };

    const handleConfirmDelete = async () => {
        try {
            const deleteResponse = await deleteFoodItem(delData?.id);
            setConfirmDialogOpen(false);
        } catch (error) {
            console.log(error, "Error in Delete FoodItem")
        }
    }

    return (
        <>
            <FoodItemsContainer
                foodItem={filteredItems}
                loading={isLoading}
                error={isError}
                searchTxt={searchQuery}
                setSearchQuery={setSearchQuery}
                handleAddBtn={handleAddBtn}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                handleToggle={handleToggle}
                togglingItemId={togglingItemId}
                isCategory={hasCategories}
                onViewAddOns={handleViewAddOns}
                categories={categoryData?.data?.records}
                selectedCategory={selectedCategory}
                onCategoryChange={setSelectedCategory}
            />

            {/* <FoodItemsModal
            open={open}
            onClose={handleClose}
            initialData={editingItems}
            onSubmit={handleSubmit}
            loading={adding || updating}
        /> */}

            <ConfirmationDialog
                open={confirmDialogOpen}
                handleClose={() => setConfirmDialogOpen(false)}
                handleConfirm={handleConfirmDelete}
                btnText="Delete"
                infoText={`Are you sure you want to delete this ${delData?.name}?`}
                // isLoading={isDeleteLoading}
                action={"Delete"}
            />

            <AddOnsViewModal
                open={viewAddOnsOpen}
                onClose={handleCloseAddOns}
                item={selectedItemForAddOns}
            />
        </>
    )
}

export default FoodItems
